import { useFeatureFlags } from '../../../../hooks/useFeatureFlags'
import { useOneTrustStore } from '../../../../hooks/useOneTrust'

/**
 * Hook to determine if experimentation features should be enabled
 */
export const useShouldEnableExperimentation = () => {
  const { getFlag } = useFeatureFlags()
  const { consent } = useOneTrustStore()

  return (
    getFlag('enable_statsig') &&
    !window.Shopify?.designMode &&
    consent.functional &&
    consent.performance
  )
}
